/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_IntroInputs */

const en_sorter_intro = /** @type {(inputs: Sorter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reorder every object key in a document so two files line up and version control diffs stop reporting noise. Nested objects are sorted at every level and array order is left alone.`)
};

const ko_sorter_intro = /** @type {(inputs: Sorter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서의 모든 객체 키를 다시 정렬해 두 파일이 나란히 맞물리게 하고, 버전 관리 diff가 의미 없는 변경을 보고하지 않게 만듭니다. 중첩 객체는 모든 단계에서 정렬되고 배열 순서는 건드리지 않습니다.`)
};

const ja_sorter_intro = /** @type {(inputs: Sorter_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書内のすべてのオブジェクトキーを並べ替え、2 つのファイルがかみ合うようにして、バージョン管理の差分が意味のない変更を報告しないようにします。ネストしたオブジェクトは各段階で並べ替えられ、配列の順序には手を付けません。`)
};

/**
* | output |
* | --- |
* | "Reorder every object key in a document so two files line up and version control diffs stop reporting noise. Nested objects are sorted at every level and arra..." |
*
* @param {Sorter_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_intro = /** @type {((inputs?: Sorter_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_intro(inputs)
	if (locale === "ko") return ko_sorter_intro(inputs)
	return ja_sorter_intro(inputs)
});